// extracted by mini-css-extract-plugin
module.exports = {"divider":"styles_divider__2n2yq","dividerTop":"styles_dividerTop__2A4Sd"};